document.addEventListener("DOMContentLoaded", (event) => {
  async function acceleratedButtonCheckout(product_id) {
      const qty = document.getElementById(`accelerated-qty-${product_id}`);
  
      const formData = {
          items: [
              {
              id: product_id,
              quantity: parseInt(qty.value),
              },
          ],
      };
  
      const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
      });
  
  
      window.location.href = "/checkout";
  
  }   

  const acceleratedButton = document.getElementById("custom-accelerated-button");
  if (acceleratedButton) {
      const product_id = acceleratedButton.getAttribute("data-product-id");
      acceleratedButton.addEventListener("click", () => {
          acceleratedButtonCheckout(product_id);
      });
  }

});
